module.exports = __webpack_public_path__ + "img/010.fabc2993.png";